/*
*   Google Maps librairy - MG2 Media
*   @author Mathilde Paccoud & François Vandal
*   @version: 0.5
*   Last update: 8/11/2017
*/

(function($, global, undefined) {
    
    'use strict';
    var win = $(window);
    var winWidth;
    
    var counter = 0;
    var distance = 15;
    var maxResults = 25;
    var eleMaps;
    var loadings;
    var mapsList = {};
    var currInfoOpen = '';
    var lang = $('html').attr('lang');
    var isUnderSm = true;
    
    var markerDefault = {
        imageName: 'map-marker.png'
    };
    
    var defaults = {
        latitude: 45.50867,
        longitude: -73.553992,
        zoom: 16,
        scrollwheel: false,
        getLocalMarker: true,
        getAjaxMarkerList: false,
        ajaxMarkerListDistance: 15,
        ajaxMarkerListMaxResults: 25,
        ajaxReloadOnClick: true,
        panX: 0,
        panY: 0,
        panMinWidth: 0
    };
    
    var getUrlVars = function () {
        var vars = [], hash;
        if (window.location.href.indexOf('?') !== -1) {
            var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for(var i = 0; i < hashes.length; i++) {
                hash = hashes[i].split('=');
                //vars.push(hash[0]);
                vars[hash[0]] = hash[1];
            }
            return vars;
        } else {
            return [];
        }
    };
    
    var centerMapByCoor = function (map, myLatlng) {
        map.setCenter(myLatlng);
    };
    
    var getMarkers = function (mapClass, distance, maxResults, element){
        var currMap = mapsList[mapClass].theMap;
        var mapCenter = currMap.getCenter();
        var mapCenterLat = mapCenter.lat();
        var mapCenterLng = mapCenter.lng();
        var loadingCtn = element.siblings('.gmap-loading');
        var loading = $('.gmap-loading-item', loadingCtn);
        
        var obj = ajax('/action/getOrganizations?lat='+mapCenterLat+'&lng='+mapCenterLng+'&distance='+distance+'&maxResults='+maxResults,function (response) {
            getJson(response, mapClass, element, loading);
        },true);
    }; 
    
    var getJson = function (response, mapClass, element, loading){
        var obj = JSON.parse(response.trim());
        var markersArray = [];
        
        var tempTotal = 0;
        for(var i=0 ; i<obj.length ; i++){
                var exists = false;
            var id = obj[i].id;
            var lat = obj[i].lat;
            var lng = obj[i].lng;
            var name = decodeText(obj[i].name);
            var point = new google.maps.LatLng(lat,lng);
            for(var x = 0; x < markersArray.length; x++) {
                if ( markersArray[x][0].getPosition().equals( point ) && markersArray[x][1] == name) {
                    exists = true;
                }
            }
            var address = decodeText(obj[i].address);
            var city = decodeText(obj[i].city);
            var postalCode = decodeText(obj[i].postalCode);
            var province = decodeText(obj[i].province);
            var markerName = decodeText(obj[i].field1);
            if(!exists && lat !== 0 && lat !== '' && lng !== 0 && lng !== ''){
                markerName = encodeText(markerName);
                addMarkerInner(id, lat, lng, name, address, city, postalCode, province, markerName, mapClass, element, markersArray);
            }
        }
        
        mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: markersArray});
        
        loading.fadeOut(3000);
        setMapBound(mapClass);
    };
    
    var addMarkerInner = function (id, lat, lng, title, markerName, mapClass, element, markersArray) {
        var currMap = mapsList[mapClass].theMap;
        
        var markerOptions = {
            imageName: element.data('makerName'),
            btnValue: element.data('popupBtnValue'),
            btnUrlBeforeId: element.data('popupUrlBeforeId')
        };
        
        var markerSettings = $.extend({}, markerDefault, markerOptions);
        
        var myLatlng = new google.maps.LatLng(lat,lng);

        var marker = new google.maps.Marker({
            position: myLatlng,
            title: name,
            icon: '/static/assets/img/' + markerSettings.imageName
        });
        markersArray.push([marker,name]);
        
        marker.setMap(currMap);
    };

    var clusterIt = function (map){
        var mc = new MarkerClusterer(map,markersArray);
    };
    
    var addSingleMarkers = function (obj, mapClass, myLatlng, loading, settings) {
        var currMap = mapsList[mapClass].theMap;
        
        var markerOptions = {
            imageName: obj.data('markerName')
        };
        
        var markerSettings = $.extend({}, markerDefault, markerOptions);
        
        
        var marker = new google.maps.Marker({
            position: myLatlng,
            title: obj.data('name'),
            icon: '/static/assets/img/' + markerSettings.imageName
        });
        
        marker.setMap(currMap);
        
        mapsList[mapClass] = $.extend(mapsList[mapClass], {markers: marker});
        
        loading.fadeOut(3000);
    };
    
    var createMaps = function () {
        eleMaps.each(function () {
            var t = $(this);
            var addedClass;
            
            if (t.attr('id') !== 0) {
                addedClass = t.attr('id');
            } else {
                addedClass = 'map-created-' + t.index();
                t.attr('id', addedClass);
            }
            
            var options = {
                latitude: t.data('latitude'),
                longitude: t.data('longitude'),
                zoom: t.data('zoom'),
                scrollwheel: t.data('scrollwheel'),
                getLocalMarker: t.data('getLocalMarker'),
                getAjaxMarkerList: t.data('getAjaxMarkerList'),
                ajaxMarkerListDistance: t.data('ajaxMarkerListDistance'),
                ajaxMarkerListMaxResults: t.data('ajaxMarkerListMaxResults'),
                ajaxReloadOnIdle: t.data('ajaxReloadOnIdle'),
                panX: t.data('panX'),
                panY: t.data('panY'),
                panMinWidth: t.data('panMinWidth'),
                disableDefaultUI: true
            };
            
            var settings = $.extend({}, defaults, options);
            
            var htmlSaveOverflow = $('html').css('overflow');
            $('html').css('overflow', 'hidden');
            if ($(window).width() >= settings.panMinWidth) {
                isUnderSm = false;
            }
            $('html').css('overflow', htmlSaveOverflow);
            
            var myLatlng = new google.maps.LatLng(settings.latitude,settings.longitude);
            var mapOptions = {
                zoom: settings.zoom,
                center: myLatlng,
                scrollwheel: settings.scrollwheel,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                disableDefaultUI: true
            };
            
            var map = new google.maps.Map(t.get(0), mapOptions);
            
            mapsList[addedClass] = {
                theMap: map,
                settings: settings
            };
            
            var styledMap = new google.maps.StyledMapType(styles,{name: "Styled Map"});
            
            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');
            
            if (loadings.length !== 0) {
                loadings.ClassyLoader({
                    width: 50,
                    height: 50,
                    fontSize: 10,
                    diameter: 20,
                    fontFamily: 'Lato'
                });
            }
            
            if (settings.panX !== 0 || settings.panY !== 0) {
                var newPanX = settings.panX;
                var newPanY = settings.panY;
                
                if (settings.panX.substr(settings.panX.length - 1) === '%') {
                    var percValueX = parseInt(settings.panX.substr(0, (settings.panX.length - 1)));
                    var mapWidth = parseInt(eleMaps.width());
                    newPanX = mapWidth / 100 * percValueX;
                }
                
                if (settings.panY.substr(settings.panY.length - 1) === '%') {
                    var percValueY = parseInt(settings.panY.substr(0, (settings.panY.length - 1)));
                    var mapHeight = parseInt(eleMaps.height());
                    newPanY = mapHeight / 100 * percValueY;
                }
                
                if (!isUnderSm) {
                    map.panBy(newPanX, newPanY);
                }
            }
            
            google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                if (settings.getLocalMarker) {
                    addSingleMarkers(t, addedClass, myLatlng, loadings, settings);
                }
                if (settings.getAjaxMarkerList && !settings.getLocalMarker) {
                    if (settings.ajaxReloadOnIdle) {
                        google.maps.event.addListener(map, 'idle', function() {
                            getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
                        });
                    } else {
                        getMarkers(addedClass,settings.ajaxMarkerListDistance,settings.ajaxMarkerListMaxResults, t);
                    }
                }
            });
        });
    };
    
    var setMapBound = function (addedClass) {
        var currMap = mapsList[addedClass].theMap;
        var markers = mapsList[addedClass].markers;
        var bounds = new google.maps.LatLngBounds();
        
        for (var i = 0; i < markers.length; i++) {
            bounds.extend(markers[i][0].getPosition());
        }
        
        currMap.fitBounds(bounds);
    };
    
    var setMapOnAll = function (map) {
        var currMap = mapsList[map];
        var currMarkers = currMap.markers;
        
        for (var i = 0; i < currMarkers.length; i++) {
            currMarkers[i][0].setMap(null);
        }
    };
    
    var clearMap = function (map) { 
        setMapOnAll(map);
        mapsList[map].markers = [];
        setMapBound(map);
    };
    
    win.on('load',function() {
        winWidth = win.width();
        eleMaps = $('.js-maps');
        loadings = $('.gmap-loading-item');
        
        createMaps();
    });
    
    
    
    var encodeText = function (name){
        name = name.replace(/\\xE0/g,'\xE0');
        name = name.replace(/\\xE2/g,'\xE2');
        name = name.replace(/\\xE3/g,'\xE3');
        name = name.replace(/\\xE4/g,'\xE4');
        name = name.replace(/\\xE5/g,'\xE5');
        name = name.replace(/\\xE9/g,'\xE9');
        name = name.replace(/\\xE8/g,'\xE8');
        name = name.replace(/\\xEA/g,'\xEA');
        name = name.replace(/\\xEB/g,'\xEB');
        name = name.replace(/\\xEE/g,'\xEE');
        name = name.replace(/\\xEF/g,'\xEF');
        name = name.replace(/\\xF1/g,'\xF1');
        name = name.replace(/\\xF2/g,'\xF2');
        name = name.replace(/\\xF3/g,'\xF3');
        name = name.replace(/\\xF4/g,'\xF4');
        name = name.replace(/\\xF6/g,'\xF6');
        name = name.replace(/\\xF9/g,'\xF9');
        name = name.replace(/\\xFB/g,'\xFB');
        name = name.replace(/\\xE7/g,'\xE7');
        name = name.replace(/\\xC0/g,'\xC0');
        name = name.replace(/\\xC7/g,'\xC7');
        name = name.replace(/\\xC8/g,'\xC8');
        name = name.replace(/\\xC9/g,'\xC9');
        name = name.replace(/\\xCA/g,'\xCA');
        name = name.replace(/\\xCE/g,'\xCE');
        name = name.replace(/\\xCF/g,'\xCF');
        name = name.replace(/\\xD1/g,'\xD1');
        name = name.replace(/\\xD4/g,'\xD4');  
        return name;
    };
    
    var decodeText = function (name){
        name = name.replace(/\\xE0/g,'à');
        name = name.replace(/\\xE8/g,'è');
        name = name.replace(/\\xE9/g,'é');
        name = name.replace(/\\xC0/g,'À');
        name = name.replace(/\\xC8/g,'È');
        name = name.replace(/\\xC9/g,'É');
        return name;
    };
    
    var styles = [
    {
        "featureType": "all",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#008eff"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "0"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "saturation": "-60"
            },
            {
                "lightness": "-20"
            }
        ]
    }
];
    
})(jQuery);